import React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";

// ALERT
function Alert({ className = "", ...props }) {
  return <div role="alert" className={`app-alert ${className}`} {...props} />;
}

function AlertTitle({ className = "", ...props }) {
  return <div className={`app-alert-title ${className}`} {...props} />;
}

function AlertDescription({ className = "", ...props }) {
  return <div className={`app-alert-description ${className}`} {...props} />;
}

// CARD
function Card({ className = "", ...props }) {
  return <div className={`app-card ${className}`} {...props} />;
}

function CardHeader({ className = "", ...props }) {
  return <div className={`app-card-header ${className}`} {...props} />;
}

function CardTitle({ className = "", ...props }) {
  return <h4 className={`app-card-title ${className}`} {...props} />;
}

function CardDescription({ className = "", ...props }) {
  return <p className={`app-card-description ${className}`} {...props} />;
}

function CardContent({ className = "", ...props }) {
  return <div className={`app-card-content ${className}`} {...props} />;
}

// INPUT
function Input({ className = "", ...props }) {
  return <input className={`app-input ${className}`} {...props} />;
}


// LABEL
function Label({ className = "", ...props }) {
  return (
    <LabelPrimitive.Root className={`app-label ${className}`} {...props} />
  );
}

// BUTTON
function Button({ className = "", ...props }) {
  return <button className={`app-button ${className}`} {...props} />;
}

export {
  Alert,
  AlertTitle,
  AlertDescription,
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  Input,
  Label,
  Button,
};
